export const getSlno=(data,offSet)=>{
        const result = data?.map((val, index) => {
            index=index+1;
          return { index: +(index*1)+ offSet, ...val };
          
        });
        return result
}